export default "__VITE_ASSET__CWBg9oeG__"